import axiosClient from "../axiosClient";

const route = "bankForBank";

export const getBanksForBank = async (filterParams) => {
  try {
    const response = await axiosClient.get(route, { params: filterParams });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBankForBankById = async (bankId) => {
  try {
    const response = await axiosClient.get(`${route}/${bankId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createBankForBank = async (bankData) => {
  try {
    const response = await axiosClient.post(`/${route}`, bankData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBankForBank = async (bankId, bankData) => {
  try {
    const response = await axiosClient.put(`${route}/${bankId}`, bankData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteBankForBank = async (bankId) => {
  try {
    const response = await axiosClient.delete(`${route}/${bankId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
